import type { MetaToken } from 'types/metaToken'

/** Retired third-party icon CDN — URLs from Mongo/config may still reference it. */
const LEGACY_DEAD_TOKEN_ICON_HOST = 'metaproprotocoltokenicon.blob.core.windows.net'

const FALLBACK_TOKEN_ICON = '/images/tokens/generic.svg'

/**
 * Safe `src` for token avatars: strips the dead legacy host and uses a local fallback when empty.
 */
export function tokenLogoSrc(logoURI: string | null | undefined): string {
  const s = logoURI?.trim()
  if (!s || s.includes(LEGACY_DEAD_TOKEN_ICON_HOST)) {
    return FALLBACK_TOKEN_ICON
  }
  return s
}

/** Use when building or returning `MetaToken` so all UI consumers get a safe `logoURI`. */
export function sanitizeMetaToken(meta: MetaToken): MetaToken {
  return { ...meta, logoURI: tokenLogoSrc(meta.logoURI) }
}
